import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { useWizard } from 'use-wizard';
import { useGetStripeProductId } from '@features/Stripe/hooks/query/use-get-stripe-product-id';
import { useGetUnsubscribePlans } from '@features/Stripe/hooks/query/use-get-unsubscribe-plans';
import { useGetUserPaymentInfo } from '@features/Stripe/hooks/query/use-get-user-payment-info';
import type { TpStripeUnsubscribeResponse } from '@features/Stripe/types';
import { LoadError } from '@features/Unsubscribe/components/load-error';
import { useGetUserFeatureFlags } from '@features/Unsubscribe/hooks/query/use-get-user-feature-flags';
import { WizardSteps } from '@features/Unsubscribe/steps/WizardSteps';
import type { TpWizardValues } from '@features/Unsubscribe/types';
import { WEB_UNSUBSCRIBE_PATHS } from '@features/Unsubscribe/сonstants';
import { useQuery } from '@tanstack/react-query';
import { getIpInfo } from 'src/utils/get-ip-info';
export const FromWeb = () => {
  const {
    query
  } = useRouter();
  const [step, wizard] = useWizard(WEB_UNSUBSCRIBE_PATHS);
  const [currentCountryCode, setCurrentCountryCode] = useState<string | undefined>(undefined);
  const {
    data: ipInfo
  } = useQuery({
    queryKey: ['ipInfo'],
    queryFn: getIpInfo,
    enabled: !currentCountryCode,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY
  });
  useEffect(() => {
    if (!currentCountryCode) {
      const countryCode = ipInfo?.countryCode || 'US';
      setCurrentCountryCode(countryCode);
    }
  }, [ipInfo, currentCountryCode]);
  const userPaymentInfo = useGetUserPaymentInfo({
    email: query?.email as string,
    userId: query?.user_id as string
  });
  const {
    productId
  } = useGetStripeProductId({
    variant: 'cancellation',
    paymentSystemRegion: userPaymentInfo?.app
  });
  const allUnsubscribeData = useGetUnsubscribePlans({
    productId: productId,
    countryCode: currentCountryCode,
    currency: userPaymentInfo?.currency
  }) as TpStripeUnsubscribeResponse | undefined;
  const {
    data: featureFlags,
    isError,
    refetch
  } = useGetUserFeatureFlags({
    userId: query?.user_id as string,
    email: query?.email as string
  });
  if (isError && !featureFlags) {
    return <LoadError onRetry={() => void refetch()} />;
  }
  return <WizardSteps {...{
    wizard,
    step: step as TpWizardValues,
    featureFlags,
    allUnsubscribeData
  }} data-sentry-element="WizardSteps" data-sentry-component="FromWeb" data-sentry-source-file="index.tsx" />;
};